import Header from '../../__Layout/Header';
import React , {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {Link } from 'react-router-dom';

import {  useSelector } from 'react-redux';
import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
import video from "../../assets/niceapms/assets/img/play-icon-png-transparent-4.jpg";
export default function StudentDashboard() {
      const navigator = useNavigate();
      const [name,setName] = useState("")
      const [lastLogin,setLastLogin] = useState("")
      const {userDetail } = useSelector(
        (state) => state.auth
      )
      
      useEffect(()=>{
        if(userDetail){
            // setName(userDetail['user'][0]['first_name']+' '+userDetail['user'][0]['last_name'])
            setName(userDetail['user'][0]['first_name'])

            setLastLogin(userDetail['user'][0]['last_login'])
        }
    },[userDetail,navigator])
     
    return (
        <div className="Home">
            <Header />
            <main id="main" className="main">
            <div className="pagetitle">
            <h1>Student Dashboard</h1>
            <nav>
                <ol className="breadcrumb">
                <li className="breadcrumb-item"><a href="index.html">Home</a></li>
                <li className="breadcrumb-item active">Student Dashboard</li>
                </ol>
            </nav>
            </div>
            <section className="section dashboard">
            <div className="row">
                <div className="col-lg-12">
                    <div className="row">
                        <div className="col-xxl-4 col-md-4">
                            <div className="card info-card sales-card">
                                <div className="card-body">
                                <h5 className="card-title">Login Information</h5>
                                <div className="d-flex align-items-center">
                                    <div className="ps-3">
                                        <p>User Name: {name}</p>
                                        <p>Last Login: {lastLogin}</p>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-4 col-md-4">
                            <div className="card info-card sales-card">
                                <div className="card-body">
                                <h5 className="card-title">Notice</h5>
                                <div className="d-flex align-items-center">
                                    <div className="ps-3">
                                        <p> Please don’t forget to pay your balance</p>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-4 col-md-4">
                            <div className="card info-card sales-card">
                                <div className="card-body">
                                <h5 className="card-title">Video</h5>
                                <div className="d-flex align-items-center">
                                    <div className="ps-3">
                                    <div className="button" >
                                        <a href="https://youtu.be/a2UNctD0imc" className="list-group-item active" target="_blank">
                                        <img src={video} style={{height:'67px'}} />
                                        <b> Watch Tutorial</b>
                                        
                                        </a>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                       
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="row">
                        <div className="col-xxl-12 col-md-12">
                        <div className="card info-card sales-card">
                         <div className="card-header bg-warning">Links</div>
                            <div className="card-body">
                                <div className='row mt-2'>
                                    <div className='col-4'>
                                       <a  href="https://www.qhseinternational.com/" target="_blank" className='btn btn-warning'>qhseinternational</a>

                                    </div>
                                    <div className='col-4 '>
                                       <a href="https://web.facebook.com/QHSEDubai/?_rdc=1&_rdr" target="_blank" className='btn btn-warning'>facebook</a>

                                    </div>
                                    <div className='col-4'>
                                       <Link to="/online-payment" className='btn btn-warning' >Online Payment</Link>

                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="row">
                        <div className="col-xxl-12 col-md-12">
                        <div className="card info-card sales-card">
                            <div className="card-body">
                                <FullCalendar
                                    plugins={[ dayGridPlugin]}
                                    initialView="dayGridMonth"
                                /> 
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                {/* <!---end chart--> */}
            </div>
            </section>
           </main>
        </div>
    );
}